import React, { FC } from 'react';

import type { SeriesType } from '~/types/series.types';

import { ChartTypeSelector } from '../chart-type-selector/ChartTypeSelector';
import { HorizonSelector } from '../horizon-selector/HorizonSelector';
import { ResampleSelector } from '../resample-selector/ResampleSelector';
import {
  RangeHorizon,
  ResampleIntervals,
} from '../resample-selector/ResampleSelector.types';
import * as S from './ViewController.styles';

export interface ViewControllerProps {
  horizonRanges: RangeHorizon[];
  selectedRange?: RangeHorizon;
  selectedResample?: ResampleIntervals;
  selectedSeriesType: SeriesType;
  onRangeChange: (range: RangeHorizon) => void;
  onResampleChange: (resample: ResampleIntervals) => void;
  onChartTypeChange: (type: SeriesType) => void;
}

export const ViewController: FC<ViewControllerProps> = ({
  selectedRange,
  selectedResample,
  selectedSeriesType,
  onRangeChange,
  onResampleChange,
  onChartTypeChange,
  horizonRanges,
}) => {
  return (
    <S.ViewControllerRoot data-testid="view-controller">
      {selectedRange && (
        <S.MenuGroup>
          <HorizonSelector
            horizonRanges={horizonRanges}
            selectedRange={selectedRange}
            onChange={onRangeChange}
          />
        </S.MenuGroup>
      )}

      {selectedResample && (
        <S.MenuGroup>
          <ResampleSelector
            selectedResample={selectedResample}
            onChange={onResampleChange}
          />
        </S.MenuGroup>
      )}

      <S.MenuGroup>
        <ChartTypeSelector
          selectedSeriesType={selectedSeriesType}
          onChange={onChartTypeChange}
        />
      </S.MenuGroup>
    </S.ViewControllerRoot>
  );
};
